module.exports = __webpack_public_path__ + "img/home_en_ID_img1.72471743.png";